import { ref } from '@vue/reactivity';
import { projectFirestore } from '@/firebase/config';

const getProjects = () => {
  const projects = ref([]);

  const error = ref();

  const load = async () => {
    try {
      const res = await projectFirestore.collection('projects').get();

      projects.value = res.docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      });
    } catch (err) {
      error.value = err.message;
    }
  };

  return { projects, error, load };
};

export default getProjects;
